jQuery(document).ready(function(){
	jQuery('.site-footer .h2.appear-delay , .site-footer .rte.rte--block.appear-delay-1').wrapAll('<div class="wrap-ftr"></div>');
  	jQuery('#shopify-section-product-template .grid').after(jQuery('#shopify-section-product-template .product-single__description.rte'));
  	jQuery('#shopify-section-product-template .product-single__description.rte').after(jQuery('#shopify-section-product-template .social-sharing'));
	jQuery('.mobile-icon').click(function(){
        jQuery('.custom-mobile-item').toggleClass('active-mobile-menu');
    });
    if(jQuery('.custom-inner-page').hasClass('shop-page-inner')){
      jQuery('body').addClass('display-ann');
    }
    if(jQuery('body').hasClass('template-collection')){
        jQuery('body').addClass('display-ann');
     }
      if(jQuery('body').hasClass('template-product')){
            jQuery('body').addClass('display-ann');
      }
});